module.exports = __webpack_public_path__ + "static/betterer-917377ab04920988a864f46a4b95721e.png";